export enum TriggerStateValueBlind {
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  CLOSED = 'CLOSED',
  OPENED = 'OPENED',
}
